import './SearchMaterials.scoped.scss';
import ClassDropDown from 'components/Header/components/ClassDropDown/ClassDropDown';
import { ReactComponent as Search } from 'assets/icons/search.svg';

import MaterialsCard from '../MaterialsCard/MaterialsCard';

const SearchMaterials: React.FC = () => {
  return (
    <div>
      <div className="search-container">
        <div className="search">
          <input
            type="text"
            className="input margin-x-10px border-radius-20px full-width"
            placeholder="Search materials"
          />
          <Search className="icon" />
        </div>
        <div className="dropdown-container">
          <ClassDropDown
            value="All"
            style={{ width: '95% ' }}
            boxStyle={{ width: '100%', left: '0px' }}
          >
            <p className="dropdown-item pointer item" onClick={() => undefined}>
              Math
            </p>
            <p className="dropdown-item pointer item" onClick={() => undefined}>
              Chemistry
            </p>
          </ClassDropDown>
        </div>
      </div>

      <div className="result-grid">
        <MaterialsCard />
        <MaterialsCard />
        <MaterialsCard />
      </div>
    </div>
  );
};

export default SearchMaterials;
